import { Button, Clickable, Col, Icon, Modal, Radio, Row, Text } from 'components';
import { Api, theme } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
  width: 240px;
  height: 80px;
  background-color: ${(props) => (props.active ? theme.SECONDARY : 'transparent')};
  margin-bottom: 24px;
  display: flex;
  ${(props) => props.useMarginRight && 'margin-right: 24px;'};
  ${(props) => !props.active && `border: 1px solid ${theme.GREY_30};`};

  @media (max-width: 1024px) {
    width: calc(100% - 32px);
    margin-right: 0;
    margin-bottom: 8px;
  }
`;

const Card = ({ item, useMarginRight, setUpdatingCards, updatingCards }) => {
  const [visible, setVisible] = useState(false),
    { t } = useTranslation();

  function handleVisible() {
    setVisible(!visible);
  }

  async function handleSelect() {
    if (item.active) return;
    setUpdatingCards(true);

    await Api.post('/billing/changeActiveCard', { cardId: item.cardId });
    setTimeout(() => {
      setUpdatingCards(false);
    }, 500);
  }

  async function removeCard() {
    setUpdatingCards(true);

    await Api.post('/billing/removeCard', { cardId: item.cardId });
    handleVisible();
    setTimeout(() => {
      setUpdatingCards(false);
    }, 500);
  }

  return (
    <React.Fragment>
      <Container active={item.active && !updatingCards} useMarginRight={useMarginRight}>
        <Row pad="16px" between wid="100%">
          <Row noFlex>
            <Radio
              active={item.active && !updatingCards}
              onClick={handleSelect}
              disabled={updatingCards}
            />

            <Col marg="0 0 0 16px" noFlex>
              <Text col={item.active ? '#fff' : '#000'}>**** {item.last4}</Text>

              <Text col={item.active ? '#fff' : '#000'}>
                {t('billing.exp')}: {item.exp}
              </Text>
            </Col>
          </Row>

          <Clickable onClick={handleVisible}>
            <Icon type="delete" col={item.active ? '#fff' : '#000'} dimensions={18} />
          </Clickable>
        </Row>
      </Container>

      <Modal visible={visible} closeModal={handleVisible}>
        <Col pad="64px" center>
          <Col centerAll wid="100%">
            <Text h3 center>
              {t('billing.removingCard')}
            </Text>

            <Text maxWid="250px" style={{ textAlign: 'center' }} marg="18px 0 0">
              {t('billing.sureToRemove', { last4: item.last4 })}
            </Text>
          </Col>

          <Row marg="30px 0 0">
            <Button big onClick={removeCard} text={t('common.remove')} marg="0 12px 0 0" />

            <Button big bordered text={t('common.cancel')} onClick={handleVisible} />
          </Row>
        </Col>
      </Modal>
    </React.Fragment>
  );
};

export default Card;
